import { Component, h, Host, Prop } from "@stencil/core";
import { removeUrlStatusParams } from "../../../utils/removeUrlStatusParams";

@Component({
    tag: "ux-iws-nav-login-link",
    styleUrl: "navigation-login-link.scss",
    shadow: false,
})
export class NavigationLoginLink {
    private baseClass: string = "ux-iws-nav-login-link";

    /** Login Link Text */
    @Prop() loginLinkText: string = "Login";

    /** identity URL */
    @Prop() idmUrl: string = "";

    private handleLoginLink = (e) => {
        e.preventDefault();

        window.location.href =
            this.idmUrl +
            "&redirect_uri=" +
            encodeURIComponent(this.getCleanedUrl());

        return false;
    };

    private getCleanedUrl = () => {
        return removeUrlStatusParams(window.location.href);
    };

    render() {
        return (
            <Host class={`${this.baseClass}`}>
                <a
                    href="#'#'#"
                    rel="nofollow"
                    onClick={(e) => this.handleLoginLink(e)}
                >
                    <span class="ux-iws-navigation-meta__icon-box">
                        <ux-icon name="nav-profile" class="ux-icon"></ux-icon>
                    </span>
                    <span class="ux-iws-navigation-meta__link-text">
                        {this.loginLinkText}
                    </span>
                </a>
            </Host>
        );
    }
}
